export class Ingresos{
    constructor(
        public _id: string,
        public cuenta: String,
        public valor: Number,
        public tipo_ingreso: String

    ){}
}